import React from 'react';

// Returns true when the click lands on the native horizontal scrollbar track,
// so callers can skip open-input logic for scrollbar drags.
export const isHorizontalScrollbarClick = (
  event: React.MouseEvent<HTMLDivElement>,
  target: HTMLElement,
  scrollContainerSelector: string
): boolean => {
  const scrollContainer = target.closest(scrollContainerSelector);

  if (!(scrollContainer instanceof HTMLElement)) {
    return false;
  }

  const scrollbarHeight =
    scrollContainer.offsetHeight - scrollContainer.clientHeight;

  if (scrollbarHeight <= 0) {
    return false;
  }

  const scrollContainerRect = scrollContainer.getBoundingClientRect();

  // Ignore native scrollbar drags so scrolling does not act like open-input click.
  return event.clientY >= scrollContainerRect.bottom - scrollbarHeight;
};
